/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Updatedat2Inputs */

const zh_accountsettings_updatedat2 = /** @type {(inputs: Accountsettings_Updatedat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新时间`)
};

const en_accountsettings_updatedat2 = /** @type {(inputs: Accountsettings_Updatedat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated At`)
};

const es_accountsettings_updatedat2 = /** @type {(inputs: Accountsettings_Updatedat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización`)
};

/**
* | output |
* | --- |
* | "Updated At" |
*
* @param {Accountsettings_Updatedat2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_updatedat2 = /** @type {((inputs?: Accountsettings_Updatedat2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Updatedat2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_updatedat2(inputs)
	if (locale === "en") return en_accountsettings_updatedat2(inputs)
	return es_accountsettings_updatedat2(inputs)
});
export { accountsettings_updatedat2 as "accountSettings_updatedAt" }